import { useSelector } from "react-redux";
import { useUserRole } from "../../utils/helperMethods";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function RFIVQAStatusTabs({
  activeTab,
  setActiveTab,
  rfiCount,
  vqaCount,
  hideVqq = false,
}) {
  const { userDetails } = useSelector((state) => state.vendorUserDetails);

  const user = useUserRole();

  // Safely extract subRoles - returns empty array if not Provider User or data not loaded
  const subRoles =
    user === "Provider User"
      ? userDetails?.provider_user_subrole?.map((role) =>
          role.subrole.toLowerCase()
        ) || []
      : [];

  const tabs = [
    ...(hideVqq
      ? []
      : [
          {
            name: "Vendor Qualification Questionnaire (VQQ)",
            value: "RFI",
            href: "#",
            count: rfiCount ? rfiCount : 0,
            current: true,
            ...(user === "Provider User" && {
              display: [
                subRoles.includes("rfi manager") || subRoles.includes("vendor admin")
                  ? "block"
                  : "none",
              ],
            }),
          },
        ]),
    {
      name: "Vendor Qualification Assessment (VQA)",
      value: "VQA",
      href: "#",
      count: vqaCount ? vqaCount : 0,
      current: hideVqq,
      ...(user === "Provider User" && {
        display: [
          subRoles.includes("vqa manager") || subRoles.includes("vendor admin")
            ? "block"
            : "none",
        ],
      }),
    },
  ];

  return (
    <div>
      <div className="sm:hidden mb-4">
        <label htmlFor="tabs" className="sr-only">
          Select a tab
        </label>
        {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
        <select
          id="tabs"
          name="tabs"
          defaultValue={tabs.find((tab) => tab.current).name}
          className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
        >
          {tabs.map((tab) => (
            <option key={tab.name}>{tab.name}</option>
          ))}
        </select>
      </div>
      <div className="hidden sm:block">
        <div className="border-b border-gray-200">
          <nav aria-label="Tabs" className="-mb-px flex space-x-8">
            {tabs.map((tab) => (
              <a
                style={{ display: tab.display }}
                key={tab.name}
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setActiveTab(tab.value);
                }}
                aria-current={tab.current ? "page" : undefined}
                className={classNames(
                  activeTab === tab.value
                    ? "border-indigo-500 text-indigo-600"
                    : "border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700",
                  "flex whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium"
                )}
              >
                {tab.name}
                {tab.count ? (
                  <span
                    className={classNames(
                      activeTab === tab.value
                        ? "bg-indigo-100 text-indigo-600"
                        : "bg-gray-100 text-gray-900",
                      "ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block"
                    )}
                  >
                    {tab.count}
                  </span>
                ) : null}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </div>
  );
}
